import { type ReactNode } from 'react'

import { cn } from '@/lib/utils'

/** Inner cluster aligned with {@link JobCard} job-board trailing (Apply, bookmark, **`trailing`**). Footer row passes **`ml-auto`** on this cluster so actions stay end-aligned when no salary/note sits left. */
export function ListCardTrailingActionCluster({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        'pointer-events-auto flex shrink-0 flex-wrap items-center gap-2',
        className,
      )}
    >
      {children}
    </div>
  )
}

/**
 * List rows without a salary/note left slot: trailing actions aligned end (same intent as JobBoard footers).
 */
export function ListCardTrailingActionsFooter({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        'flex w-full min-w-0 flex-row flex-wrap items-center justify-end gap-3',
        className,
      )}
    >
      <ListCardTrailingActionCluster>{children}</ListCardTrailingActionCluster>
    </div>
  )
}
